var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareMessenger(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.964,
    y1: 0.041,
    x2: -0.097,
    y2: 1.195,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fb5185"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.135,
    stopColor: "#e64aa2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226,
    stopColor: "#d645b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#be3dd7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#9c37fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568,
    stopColor: "#6e54ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.658,
    stopColor: "#476cff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    stopColor: "#0e8bf1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835,
    stopColor: "#1398f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1398f6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-127 -709)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 10,
    transform: "translate(127 709)",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.173,287.213a10.03,10.03,0,0,0-7.468,16.726c.495.552-1.006,3.883-.4,4.314.578.412,3.258-2.071,3.917-1.788a10.031,10.031,0,1,0,3.951-19.252Zm6.772,8.328-5.527,4.835a.181.181,0,0,1-.234-.024l-2.272-2.39a.181.181,0,0,0-.2-.041l-4.718,2.066a.181.181,0,0,1-.191-.3l5.305-5.6a.181.181,0,0,1,.258.021l2.406,2.875a.181.181,0,0,0,.2.053l4.808-1.807A.181.181,0,0,1,207.945,295.541Z",
    transform: "translate(-54.173 431.244)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareMessenger);
export default __webpack_public_path__ + "static/media/shareMessenger.f824f11651620e480fe110304f43e7ef.svg";
export { ForwardRef as ReactComponent };